import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WindowsOpenIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.697 4C13.9109 4 15.0484 4.59227 15.7445 5.58672L20.0002 11.6663V19.9H4.1002V12.85H4.1001V7.59412H4.1002V4H12.697ZM14.4949 11.0499L13.489 9.37335C12.8267 8.26952 11.6338 7.59412 10.3465 7.59412H5.9002V5.8H12.697C13.3235 5.8 13.9106 6.10569 14.2699 6.61896L17.3716 11.0499H14.4949ZM5.9002 12.85H15.575L15.5749 12.8499H18.2002V18.1H5.9002V12.85Z"
      />
    </SvgIcon>
  );
});
